const currentYear = new Date().getFullYear()

const yearsSinceGetapp = currentYear - 2010

export { yearsSinceGetapp }
